// oauth-client/client/loginWithOAuth.ts
import { goTo } from "@adornis/router/client/open-href.js";
var loginWithOAuth = async ({
  successRedirect = location.href,
  silent,
  providerName = "default"
} = {}) => {
  const params = new URLSearchParams({ successRedirect });
  if (silent)
    params.set("silent", "1");
  const routePrefix = providerName === "default" ? "/api/oauth-client" : `/api/oauth-client/${providerName}`;
  goTo(`${routePrefix}/login?${params.toString()}`, { target: "_parent" });
};
export {
  loginWithOAuth
};
